import classNames from 'classnames';
import { forwardRef } from 'react';
const fieldWrapperInvalidCss = "ff2y27r";
const fieldWrapperCss = "fb6nh5y";
export const FieldWrapper = forwardRef((props, ref) => {
  const {
    invalid,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldWrapperCss, {
    [fieldWrapperInvalidCss]: invalid
  }, props.className)} />;
});
const fieldLabelCss = "f19a1qc3";
export const FieldLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(fieldLabelCss, props.className)} />;
});
const fieldInputCss = "f1htktsu";
export const FieldInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(fieldInputCss, props.className)} />;
});

require("./field_parts.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./field_parts.js");